module.exports = __webpack_public_path__ + "img/corona.65fa5670.svg";